import { render } from "./VillageNpc1.vue?vue&type=template&id=be018976&scoped=true"
import script from "./VillageNpc1.vue?vue&type=script&lang=js"
export * from "./VillageNpc1.vue?vue&type=script&lang=js"

import "./VillageNpc1.vue?vue&type=style&index=0&id=be018976&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be018976"]])

export default __exports__